import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useField, useFormikContext } from 'formik';
export function SubmitSelection() {
    var _a;
    const { submitForm, isSubmitting } = useFormikContext();
    const [field] = useField('id');
    const hasPair = Boolean((_a = field.value) === null || _a === void 0 ? void 0 : _a.length);
    const update = t({
        message: 'Update',
        comment: 'Add Metadata Pair: Filesystem reference - Update value button',
    });
    const save = t({
        message: 'Save',
        comment: 'Add Metadata Pair: Filesystem reference - Save value button',
    });
    return (<Menu.Item onClick={submitForm} disabled={isSubmitting}>
      <Falcon icon="floppy-disk"/>
      {hasPair ? update : save}
    </Menu.Item>);
}
